import { useTranslation } from 'react-i18next';
import { StyledLoaderContainer, StyledLoadingButton } from './styled';

interface PropsType {
  isFetching: boolean;
  onLoadMore: () => void;
}

const LoadMoreButton = ({ isFetching, onLoadMore }: PropsType) => {
  const { t } = useTranslation();

  return (
    <StyledLoaderContainer>
      <StyledLoadingButton
        variant="outlined"
        loading={isFetching}
        onClick={onLoadMore}
      >
        {t('general:action:loadMore')}
      </StyledLoadingButton>
    </StyledLoaderContainer>
  );
};

export default LoadMoreButton;
